import { marked } from "marked";

export const SOURCE_LANGS = [
  { value: 'eng', label: 'English' },
  { value: 'hin', label: 'Hindi' },
  { value: 'pan', label: 'Punjabi' },
  { value: 'tel', label: 'Telugu' },
  { value: 'urd', label: 'Urdu' },
  { value: 'ben', label: 'Bengali' },
];

export const DOMAINS = [
  { value: 'general', label: 'General' },
  { value: 'all', label: 'All' },
  { value: 'retail', label: 'Retail' },
  { value: 'desh', label: 'Desh' },
  { value: 'cricket', label: 'Cricket' },
  { value: 'entertainment', label: 'Entertainment' },
];

const renderPandocImages = (md = "") =>
  md.replace(
    /!\[([^\]]*)\]\(([^)]+)\)\{([^}]*)\}/g,
    (_, alt, src, attrs) => {
      let styles = "display:inline; vertical-align:middle;";
      attrs.replace(/(\w+)\s*=\s*"([^"]+)"/g, (_, key, value) => {
        styles += `${key}:${value};`;
      });
      return `<img src="${src}" alt="${alt}" style="${styles}" />`;
    }
  );

// 🔹 Convert Pandoc-style images


export   const renderHTML = (md) => ({
  __html: marked.parse(renderPandocImages(md || "")),
});


export const isMarkdownSyntax = (word) => {
  if (!word || word.trim() === '') return true;

  const trimmed = word.trim();

  // ─── Headings ───
  if (/^#{1,6}$/.test(trimmed)) return true;
  if (/^#{1,6}\s/.test(word)) return true; // # Heading

  // ─── Inline formatting ───
  if (['**', '*', '_', '__', '~~', '`', '```', '``'].includes(trimmed)) return true;

  // ─── Links & basic image markers ───
  if (['[', ']', '(', ')', '!'].includes(trimmed)) return true;

  // ─── Full Pandoc-style image syntax protection ───
  // Detect complete image markup like: ![](url){attrs} or ![alt](url){attrs}
  if (
    trimmed.startsWith('![') ||
    trimmed.startsWith('](') ||
    trimmed.includes('){') ||           // closing part with attributes
    trimmed.includes('width=') ||
    trimmed.includes('height=') ||
    trimmed.includes('.png') || trimmed.includes('.jpg') || trimmed.includes('.jpeg') || trimmed.includes('.gif') // common image extensions
  ) {
    return true;
  }

  // ─── Lists ───
  if (['-', '*', '+', '1.', '2.', '0.', '- [ ]', '- [x]', '* [ ]', '* [x]'].includes(trimmed)) {
    return true;
  }

  // ─── Blockquotes, HR, tables ───
  if (trimmed === '>' || trimmed === '---' || trimmed === '***' || trimmed === '___') return true;
  if (trimmed === '|' || trimmed === ':--' || trimmed === '--:' || trimmed === ':---:') return true;

  // ─── Pure whitespace ───
  if (/^\s*$/.test(word)) return true;

  return false;
};